import React, { useState, useCallback, useMemo, useEffect } from "react";
import HeaderCard from "../HeaderCard/HeaderCard";
import styles from "./GeneralSettings.module.css";
import { ReactComponent as GeneralIcon } from "../../assets/GeneralSettingIcon.svg";
import { ReactComponent as AccountSettingIcon } from "../../assets/AccountSettingIcon.svg";
import { ReactComponent as TeamSettingIcon } from "../../assets/TeamSettingIcon.svg";
import { ReactComponent as DataControlsSettingIcon } from "../../assets/DataControlsSettingIcon.svg";
import { ReactComponent as ConnectedAppsSettingIcon } from "../../assets/ConnectedAppsSettingIcon.svg";
import { ReactComponent as WorkspaceIcon } from "../../assets/WorkspaceIcon.svg";
import { ReactComponent as SecuritySettingIcon } from "../../assets/SecuritySettingIcon.svg";
import { ReactComponent as SubscriptionIcon } from "../../assets/subscriptionIcon.svg";
import { ReactComponent as SpeechIcon } from "../../assets/speechIcon.svg";
import General from "./components/General";
import Team from "./components/Team/Team";
import AccountSettings from "../AccountSettings/AccountSettings";
import DataControls from "./components/DataControls/DataControls";
import ConnectedApps from "./components/ConnectedApps/ConnectedApps";
import Security from "./components/Security/Security";
import Speech from "./components/Speech/Speech"
import Button from "../Button/Button";
import { updateAccount, getTokens } from "../../../../actions/user";
import { useDispatch, useSelector } from "react-redux";
import i18n from "../../../../i18";
import { useTranslation } from "react-i18next";
import GetPlus from "./components/GetPlus/GetPlus";
import { useLocation, useNavigate } from "react-router-dom";
import { defaultPaymentIntent, deletePaymentIntent } from "../../../../actions/stripe";
import Workspace from "./components/Workspace/Workspace";
// import Device from "./components/Device/Device";
import Device from "./components/Device/Device.jsx";
// import { ReactComponent as DeviceIcon } from "../../assets/DeviceIcon.svg";


const GeneralSettings = ({
  showSidebar,
  setShowSidebar,
  setDeleteChats,
  setShowColorPicker,
  colors,
  openModalAutomate,
  setSeeBill,
  setTypeDelete,
  setShowTokenModal,
  setShowAddPayMethodPopup,
  currentSetting,
  setEditingCurrency,
  editingCurrency,
  selectedCurrency, 
  setSelectedCurrency,
  userData, 
  setUserData,
  initialUserData, 
  setInitialUserData,
  maxAccount,
  setShowWorkspace,
  showWorkspace,
  setShowInviteToWorkspace,
  configuration,
  setConfiguration
}) => {
  const [t] = useTranslation("accountSetting");
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState("general");
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.user);
  const [defaultPayMethod, setDefaultPayMethod] = useState(null)
  const [deletePayMethods, setDeletePayMethods] = useState([])

  const [selectedLanguage, setSelectedLanguage] = useState(
    user?.language || "Español"
  );

  const [hasChanges, setHasChanges] = useState(false);


  const handleClick = useCallback((id) => {
    console.log('id', id)
    let basePath = location.pathname;

    basePath = basePath.replace(/\/settings\/[^\/]+/, '');

    basePath = basePath.replace(/\/$/, '');

    const newPath = `${basePath}/settings/${id}`;

    navigate(newPath);
  }, [location, navigate]);

  useEffect(()=> {
    dispatch(getTokens({id: user?.id?.split("_").pop()}))
  },[])


  useEffect(() => {
    setSelectedOption(currentSetting)
  }, [currentSetting])

  useEffect(() => {
    if (userData) {
      setUserData((prevUserData) => ({
        ...prevUserData, 
        colorPrimary: colors?.color1,
        colorSecundary: colors?.color2,
      }));
    }
  }, [colors]); 
  useEffect(() => {
    if (userData && initialUserData) {
      const hasDataChanged = JSON.stringify(userData) !== JSON.stringify(initialUserData);
      setHasChanges(hasDataChanged);
    }
  }, [userData, initialUserData]);

  const settingsOptions = [
    { id: "general", icon: <GeneralIcon />, label: t("general") },
    { id: "account", icon: <AccountSettingIcon />, label: t("account") },
    { id: "devices", icon: <AccountSettingIcon />, label: 'Devices' },
     {
     id: "speech",
     icon: <SpeechIcon />,
     label: t("speech"),
   },
    // { id: "team", icon: <TeamSettingIcon />, label: t("team") },
    { id: "getPlus", icon: <SubscriptionIcon />, label: t("getPlus") },
    {
      id: "workspace",
      icon: <WorkspaceIcon />,
      label: t("Workspace"),
    },
   
    {
      id: "dataControls",
      icon: <DataControlsSettingIcon />,
      label: t("dataControls"),
    },
    {
      id: "connectedApps",
      icon: <ConnectedAppsSettingIcon />,
      label: t("connectedApps"),
    },
    { id: "security", icon: <SecuritySettingIcon />, label: t("security") },
  ];

  const settingsComponents = {
    general: () => (
      <General
        setDeleteChats={setDeleteChats}
        setShowColorPicker={setShowColorPicker}
        colors={colors}
        userData={userData}
        setUserData={setUserData}
        setSelectedCurrency={setSelectedCurrency}
        selectedCurrency={selectedCurrency}
        setSeeBill={setSeeBill}
        setSelectedLanguage={setSelectedLanguage}
        setTypeDelete={setTypeDelete}
        setEditingCurrency={setEditingCurrency}
        editingCurrency={editingCurrency}
        maxAccount={maxAccount}
        configuration={configuration}
          setConfiguration={setConfiguration}
      />
    ),
    account: () => (
      <AccountSettings
        setUserData={setUserData}
        userData={userData}
        initialUserData={initialUserData}
        setShowAddPayMethodPopup={setShowAddPayMethodPopup}
        setDeletePayMethods={setDeletePayMethods}
        setDefaultPayMethod={setDefaultPayMethod}
      />
    ),
    devices: () => (<Device />),
    speech:() => (<Speech userData={userData} setUserData={setUserData}/>),
    team: () => (<Team />),
    getPlus: () => (<GetPlus />),
    workspace: () => (<Workspace showWorkspace={showWorkspace} setShowWorkspace={setShowWorkspace} setShowInviteToWorkspace={setShowInviteToWorkspace} />),
    dataControls: () => (<DataControls setDeleteChats={setDeleteChats} setTypeDelete={setTypeDelete} setShowSidebar={setShowSidebar} />),
    connectedApps: () => ( <ConnectedApps openModalAutomate={openModalAutomate} setShowTokenModal={setShowTokenModal} /> ),
    security: () => (<Security />),
  };

  const renderedOptions = useMemo(
    () =>
      settingsOptions.map(({ id, icon, label }) => (
        <li
          key={id}
          onClick={() => id !== "team" && handleClick(id)}
          className={`${selectedOption === id ? styles.selected : ""} ${id === "team" && styles.disabledOption} ${id == 'getPlus' && styles.getPlusOption}`}
        >
          {icon} {label}
        </li>
      )),
    [selectedOption, handleClick, t]
  );


  // let SelectedComponent = null;
  // // const [SelectedComponent, setSelectedComponent] = useState(null);

  // useEffect(() => {
  //   if(selectedOption){
  //     SelectedComponent = settingsComponents[selectedOption]
  //   } else {
  //     SelectedComponent = null
  //   }
  // }, [selectedOption]);


  const SelectedComponent = selectedOption
    ? settingsComponents[selectedOption]
    : null;

    console.log('SelectedComponent', selectedOption, SelectedComponent)

  const handleSave = async () => {
    console.log('esto es userData',userData)
    const userDataToSave = {
      ...userData,

      currency: selectedCurrency,
    };
    i18n.changeLanguage(userData?.language);
    localStorage.setItem("language", userData?.language);
    console.log('esto es userDataToSave',userDataToSave)
    dispatch(updateAccount({ data: userDataToSave }));
    setInitialUserData(userData); 
    setHasChanges(false);

    for (const paymentId of deletePayMethods) {
      await dispatch(deletePaymentIntent({ paymentMethodId: paymentId }));
    }

    if (defaultPayMethod) {
      await dispatch(defaultPaymentIntent({ paymentMethodId: defaultPayMethod }));
    }
  };
  return (
    <div className={styles.GeneralSettings}>
      <HeaderCard title={t("setting")} setState={(value) => {
        setShowSidebar(value)
        const path = location.pathname;

        const cleanedPath = path.replace(/\/settings\/[^\/]+$/, '');

        navigate(cleanedPath);
      }}>
        {currentSetting === 'workspace' ? (
          <Button type="white" headerStyle={{ borderRadius: "999px" }} action={() => setShowWorkspace(true)}><WorkspaceIcon /> {t('newWorkspace')}</Button>
        ) :

          hasChanges && <Button action={handleSave}>{t("save")}</Button>
        }
      </HeaderCard>
      <div className={styles.GeneralSettingsContent}>
        <div className={styles.leftGeneralSetting}>
          <div className={styles.optionsSetting}>
            <ul>{renderedOptions}</ul>

          </div>
        </div>
        <div className={styles.rightGeneralSetting}>
          {SelectedComponent ? <SelectedComponent /> : t("selectAnOption")}
        </div>
      </div>
    </div>
  );
};

export default GeneralSettings;
